/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HistoryMemoRequest } from '../models/HistoryMemoRequest';
import type { PaginatedResponse_TaskGroupResponse_ } from '../models/PaginatedResponse_TaskGroupResponse_';
import type { TaskGroupCreateRequest } from '../models/TaskGroupCreateRequest';
import type { TaskGroupResponse } from '../models/TaskGroupResponse';
import type { TaskGroupSortRequest } from '../models/TaskGroupSortRequest';
import type { TaskGroupUpdateRequest } from '../models/TaskGroupUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskGroupService {
    /**
     * Create Task Group
     * 전략과제 생성
     *
     * 새로운 전략과제를 생성합니다.
     * @returns TaskGroupResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskGroup({
        requestBody,
    }: {
        requestBody: TaskGroupCreateRequest,
    }): CancelablePromise<TaskGroupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/group',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Task Groups
     * 전략과제 목록 조회 및 검색
     *
     * 전략과제를 페이징하여 조회하거나 키워드로 검색합니다.
     *
     * Args:
     * q: 검색 키워드 (선택사항)
     * workspace_id: 워크스페이스 ID로 필터링 (선택사항)
     * business_id: 사업 ID로 필터링 (선택사항)
     * @returns PaginatedResponse_TaskGroupResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListTaskGroups({
        q,
        workspaceId,
        businessId,
        page = 1,
        perPage = 100,
    }: {
        q?: string,
        workspaceId?: string,
        businessId?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_TaskGroupResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/group',
            query: {
                'q': q,
                'workspace_id': workspaceId,
                'business_id': businessId,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Group
     * 전략과제 조회
     *
     * ID로 특정 전략과제를 조회합니다.
     * @returns TaskGroupResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskGroup({
        groupId,
    }: {
        groupId: string,
    }): CancelablePromise<TaskGroupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/group/{group_id}',
            path: {
                'group_id': groupId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Group
     * 전략과제 정보 수정
     *
     * 특정 전략과제의 정보를 수정합니다.
     * @returns TaskGroupResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskGroup({
        groupId,
        requestBody,
    }: {
        groupId: string,
        requestBody: TaskGroupUpdateRequest,
    }): CancelablePromise<TaskGroupResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/group/{group_id}',
            path: {
                'group_id': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Task Group
     * 전략과제 삭제
     *
     * 특정 전략과제를 삭제합니다. (소프트 삭제)
     * 선택적으로 body 에 memo 를 담으면 history 에 기록됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsTaskViewsDeleteTaskGroup({
        groupId,
        requestBody,
    }: {
        groupId: string,
        requestBody?: HistoryMemoRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/task/group/{group_id}',
            path: {
                'group_id': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Group Sort
     * 전략과제 정렬 순서 변경
     *
     * prev_task_group_id와 next_task_group_id 사이로 정렬 순서를 변경합니다.
     * - 맨 앞으로 이동: prev_task_group_id=None, next_task_group_id=첫번째ID
     * - 맨 뒤로 이동: prev_task_group_id=마지막ID, next_task_group_id=None
     * - 중간으로 이동: prev_task_group_id=이전ID, next_task_group_id=다음ID
     * @returns TaskGroupResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskGroupSort({
        groupId,
        requestBody,
    }: {
        groupId: string,
        requestBody: TaskGroupSortRequest,
    }): CancelablePromise<TaskGroupResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/task/group/{group_id}/sort',
            path: {
                'group_id': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
